module.exports = "/_next/static/images/lt-7e3fe92fd2738fe0c1f38fd0f64035ec.svg";